import { makeStyles } from "@material-ui/core"
import { TextField } from "@mui/material"
import React, { Fragment, useState } from "react"
import { getLog } from "../helpers/helpers"
import { verify_address_type_bsv, verify_address_type_token } from "../helpers/verify_address_type"
import { Row } from "./Row"
import RowWithTitle from './RowWithTitle'


const useStyles = makeStyles((theme) => ({

	red: {
		color: "red",
	},

	redInput: {
		borderColor: "red",
		outline: 0,
		boxShadow: "0 0 0 0.01rem red",
	},

	green: {
		color: "limegreen",
	},

	yellow: {
		color: "#ffc107",
	}

}))


/**
 *  props:
 * 		- tokenName		(string)		for display
 * 		- tokenID		(string)		kept for compatibility (no longer used for verification)
 * 		- variant		("bsv"|"token")	which verifier to use; defaults to "token"
 * 		- onValidChange (callback)		func that calls useState to set value
 * 		- value 		(string var)	var from useState (useful to reset field)
 * 		- title			(string)		title to display above input field
 * 
*/
export default function InputTokenAddress(props) {
	const classes = useStyles()

	const classname = "InputTokenAddress: "
	const function_id = classname
	const log = getLog(function_id)

	const [inputValue, set_inputValue] = useState("")

	const [mess_problem, set_mess_problem] = useState(null)
	const [mess_valid, set_mess_valid] = useState(null)
	const [mess_unsure, set_mess_unsure] = useState(null)

	// if parent component asked to reset
	if ((props.value == null || props.value === "") && inputValue !== "") {
		set_inputValue("")
		reset_mess()
	}

	function reset_mess() {
		set_mess_problem(null)
		set_mess_valid(null)
		set_mess_unsure(null)
	}

	function onChangeValue(event) {
		var new_value = event.target.value

		new_value = new_value.replace(/ /g, "") // remove all spaces
		set_inputValue(new_value)

		reset_mess()

		if (new_value && new_value.length > 0) {

var [send_address_is_tokenID, res_mess] =
			(props.variant === "bsv")
				? verify_address_type_bsv(new_value)
				: verify_address_type_token(new_value)

			log("send_address_is_tokenID=", send_address_is_tokenID, res_mess)

			if (send_address_is_tokenID === 0) {
				set_inputValue("")  // empty field if type is wrong
				set_mess_problem(res_mess)
				props.onValidChange("") // necessary for proper reset in parent
			}
			else if (send_address_is_tokenID === 1) {
				set_mess_valid(res_mess)
				props.onValidChange(new_value)
			}
			else {
				set_mess_unsure(res_mess)
				props.onValidChange(new_value)
			}
		} else props.onValidChange("") // necessary for proper reset in parent
	}

	let helperText_TextField = "", color_TextField = ""
	if (mess_problem) helperText_TextField = <span className={classes.red}>{mess_problem}</span>
	else if (mess_valid) {
		helperText_TextField = <span className={classes.green}>{mess_valid}</span>
		color_TextField = "success"
	} else if (mess_unsure) {
		helperText_TextField = <span className={classes.yellow}>{mess_unsure}</span>
		color_TextField = "warning"
	}

	return (
		// <RowWithTitle title={props.title}>
		<Row>

			{/* <input 
				type='text'
				value={inputValue}
				onChange={onChangeValue}
				id='inputValue'
				placeholder={"Entrez une adresse "+props.tokenName}
				className={'item '+(mess_problem?classes.redInput:"")}
			/> */}

			<TextField fullWidth
				id="outlined-basic" variant="outlined"
				label={<span>{props.title}</span>}
				value={inputValue ? inputValue : ""}
				onChange={onChangeValue}
				placeholder={"Entrez une adresse " + props.tokenName}
				error={!!mess_problem}
				helperText={helperText_TextField}
				color={color_TextField}
			/>
		</Row>
	)
}
